import {Cureus} from '../Cureus';

Cureus.Forms = {}

//= require_tree ./Forms
